export var FETCH_RECHARGE_EXPAY = 'FETCH_RECHARGE_EXPAY';
export var SUCCESS_FETCH_RECHARGE_EXPAY = 'SUCCESS_FETCH_RECHARGE_EXPAY';
export var FAILURE_FETCH_RECHARGE_EXPAY = 'FAILURE_FETCH_RECHARGE_EXPAY';
export var CLEAR_RECHARGE_EXPAY = 'CLEAR_RECHARGE_EXPAY';
export var FETCH_CHECK_EXPAY_STATUS = 'FETCH_CHECK_EXPAY_STATUS';
export var SUCCESS_FETCH_CHECK_EXPAY_STATUS = 'SUCCESS_FETCH_CHECK_EXPAY_STATUS';
export var FAILURE_FETCH_CHECK_EXPAY_STATUS = 'FAILURE_FETCH_CHECK_EXPAY_STATUS';



// WEBPACK FOOTER //
// ./src/actions/recharge/expay.js